import React, { useContext } from 'react';
import GroupsLogs from 'src/containers/groups/leadersView/groupLog';
import groupService from 'src/services/api/groupService';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import { ListsContext } from 'src/services/contextProviders/lists/listsContext';
import { seminary } from 'src/components/helpers';
import LeadersAdminAllGroups from 'src/containers/groups/leadersView/allGroups';
import { GroupsRegistrationComponent } from 'src/assets/styles/components/groupsRegistration';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

const LeadersAdminGroup = (props) => {
  const [loading, set_loading] = React.useState(false);
  const [Step, setStep] = React.useState('check');
  const [inputs, setInputs] = React.useState({});
  const { groupCategories } = useContext(ListsContext);
  const getCaptchaToken = useRecaptchaToken('group_login');

  let query = props.location.search;
  let parsedQueryString = queryString.parse(query);

  const getInfo = async (extraProps = {}) => {
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    let captcha = extraProps.captcha;
    if (captchaRequired && !captcha) {
      captcha = await getCaptchaToken({ skip: false });
      if (!captcha) {
        set_loading(false);
        Swal.fire(RECAPTCHA_SECURITY_ERROR);
        return;
      }
    }

    groupService
      .getAllGroupsByLeader({
        ...inputs,
        ...extraProps,
        ...(captchaRequired ? { captcha } : {}),
      })
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          if (response.data.message)
            return Swal.fire(
              response.data.message,
              'Si crees que es un error revisa con los encargados',
              'warning'
            );
          if (response.data.groups && response.data.found) {
            setInputs({
              ...inputs,
              groups: response.data.groups,
              groupsLeaders: response.data.groupsLeaders,
            });
            setStep('summary');
          }
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(false);
      });
  };

  React.useEffect(() => {
    const kind = parsedQueryString.kindgroup || '';
    setInputs({
      ...inputs,
      activityName: parsedQueryString.activityName || '',
      kindgroup: kind,
      kind,
      identification: parsedQueryString.identification,
      phone: parsedQueryString.phone,
    });
  }, []);

  const isCouples =
    (inputs.activityName && inputs.activityName.includes('Parejas')) || inputs.coupleleadered;

  const kindgrouplist = inputs.kindgroup === 'Grupo_Seminario' ? seminary : groupCategories;

  const stepRender = () => {
    if (Step === 'check') {
      return (
        <GroupsLogs
          parsedQueryString={parsedQueryString}
          setInputs={setInputs}
          inputs={inputs}
          getInfo={getInfo}
          leaders
          next="list"
          kindgrouplist={kindgrouplist}
          setStep={setStep}
          set_loading={set_loading}
          loading={loading}
        />
      );
    } else if (Step === 'summary') {
      return (
        <LeadersAdminAllGroups
          inputs={inputs}
          setInputs={setInputs}
          isCouples={isCouples}
          getInfo={getInfo}
          kindgrouplist={kindgrouplist}
          loading={loading}
          history={props.history}
        />
      );
    } else {
      return <p>Cargando</p>;
    }
  };

  return Step === 'summary' ? (
    <div style={{ width: '100%', padding: '1rem', boxSizing: 'border-box' }}>{stepRender()}</div>
  ) : (
    <GroupsRegistrationComponent>{stepRender()}</GroupsRegistrationComponent>
  );
};

export default LeadersAdminGroup;
